import React, { useCallback, useEffect, useState } from "react";
import { Breadcrumb, Col, Row } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import Graybg from "../../../UI/Graybg";
import Card from "../../../UI/Card/Card";
import Input from "../../../UI/Input/Input";
import Select from "../../../UI/Select/Select";
import SecBTN from "../../../UI/SecBTN";
import classes from "./UpdateUser.module.css";
import ConfirmationModal from "../../../UI/ConfirmationModal/ConfirmationModal";
import SuccessModal from "../../../UI/SuccessModal/SuccessModal";
import userService from "../../../app/services/user.service";
import Loader from "../../../UI/loader/loader";
import { toast, ToastContainer, Zoom } from "react-toastify";
import ReactSwitch from "react-switch";
import MultiSelectDropdown from "../../../UI/MultiSelectDropdown/MultiSelectDropdown";
import Toast from "../../../UI/Toast/Toast";
     
const UpdateUser = () => {
  // const { id } = useParams();
  const location = useLocation()
  const id = location.state.user_id;
  const x = JSON.parse(localStorage.getItem("user"));
  //MODAL STATES
  const [showPopUp1, setShowPopUp1] = useState(false);
  const [showPopUp2, setShowPopUp2] = useState(false);
  //loader
  const [loading, setLoading] = useState(false);
  const [profileList, setProfileList] = useState([]);
  const [centerList, setCenterList] = useState([]);
  const [teamInfoList, setTeamInfoList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [checked, setChecked] = useState(null);
  console.log('updateuser called');
    //user data state
    const data = {
      user_id: "",
      user_name: "",
      name: "",
      mobile: "",
      password: "",
      cnf_password: "",
      email: "",
      profile_id: "",
      center_id: "",
      team_lead_id: "",
      active: "",
      user_edited: x?.data?.user?.user_id,
      subject: [],
    };
  
    const [userData, setUserData] = useState(data);
  const onHideHandler = () => {
    setShowPopUp1(false);
    setShowPopUp2(false);
  };
  useEffect(() => {
      //setLoading(true);
      userService
      .getSubjectList()
      .then((data) => setSubjectList(data.data.data))
      userService.getUserData(id).then((res) => {
        let datas = res.data.data;
        let data = datas[0]
        console.log(datas)
        setUserData((prev) => {
          return {
            ...prev,
            user_id: data.user_id,
            user_name: data.user_name,
            name: data.NAME,
            mobile: data.mobile,
            password: data.pswd,
            cnf_password: data.pswd,
            email: data.email,
            profile_id: data.profile_id,
            center_id: data.center_id,
            team_lead_id: data.team_lead,
            active: data.active,
            subject: data.sub,
          }
        });
        setChecked(data.active === 1)
      });
      userService
        .getProfileList()
        .then((data) => setProfileList(data.data.data));
      userService.getCenterList().then((data) => setCenterList(data.data.data));
      userService
        .getTeamInfoList()
        .then((data) => setTeamInfoList(data.data.data))
        .then(() => setLoading(false));
       
  }, []);
  let res;
  if(userData.subject){
    res = subjectList.filter((x) =>
    userData.subject.some((y) => y.sub_id === x.sub_id)
    )
    console.log(res)
} else {
    document.location.reload()
  }

  const handleSwitch = nextChecked => {
    setChecked(nextChecked);
    if(nextChecked){
      setUserData((prev) => {
          return { ...prev, active: 1 };
           });
    }else{
      setUserData((prev) => {
           return { ...prev, active: 0 };
         });
    }
  };
  const onMultiSelect = (selectedList) => {
    setUserData(prev => {
      return {
        ...prev,
        subject:selectedList
      }
    })
  }
  const onMultiRemove = (selectedList) => {
    setUserData(prev => {
      return {
        ...prev,
        subject:selectedList
      }
    })
  }
  const submitHandler = (e) => {
    e.preventDefault();
    if(res.length !== 0){
      setUserData((prev) => {
        return {
          ...prev,
          subject:res
        }
      })
    }
    setShowPopUp1(true);
  };
  const yesHandler = useCallback(() => {
    setShowPopUp1(false);
    //console.log(userData.mobile.length);
    if (userData.password !== userData.cnf_password) {
      toast.error("Password doesn't match !!");
      return;
    }
    // if ( userData.mobile === null || userData.mobile.length !== 10) {
    //   toast.error("Enter 10 digit mobile number");
    //   return;
    // }
    // if (userData.name.length === 0 || userData.name === null) {
    //   toast.error("Enter name");
    //   return;
    // }
    // if (userData.user_name.length === 0 || userData.user_name === null) {
    //   toast.error("Enter User Name");
    //   return;
    // }
    let body = {
          user_id: userData.user_id,
          user_name: userData.user_name,
          name: userData.name,
          mobile: userData.mobile,
          pswd: userData.password,
          email: userData.email,
          profile_id: userData.profile_id,
          center_id: userData.center_id,
          team_lead: userData.team_lead_id,
          active: userData.active,
          updated_by: userData.user_edited,
          details: userData.subject,
    };
    // console.log(userData);
    // console.log(body);
    // console.log(body);
    setLoading(true);
    userService
      .updateUser(body)
      .then((res) => {
        setLoading(false);
        console.log(res);
        setShowPopUp2(true);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          toast.error(error.response.data.message);
        } else if (error.request) {
          toast.error("network error");
        } else {
          console.log(error);
          toast.error(error);
        }
      });
  }, [
    id,
    userData.user_id,
    userData.user_edited,
    userData.active,
    userData.center_id,
    userData.subject,
    userData.cnf_password,
    userData.email,
    userData.mobile,
    userData.name,
    userData.password,
    userData.profile_id,
    userData.team_lead_id,
    userData.user_name
  ]);
  return (
    <div className="section">
      {loading && <Loader />}
      <ConfirmationModal
        title={`Are you sure you want to Update User?`}
        show={showPopUp1}
        onHide={onHideHandler}
        yesHandler={yesHandler}
        confirmTxt="yes"
      />
      <SuccessModal
        show={showPopUp2}
        onHide={onHideHandler}
        title={`User Updated Successfully!`}
        btnTxt="Ok"
      />
      <Toast />
      <h4>User's List</h4>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/userList">User's List</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{userData.user_name}</Breadcrumb.Item>
      </Breadcrumb>
      <Graybg>
        <h6 className="mb-2">Edit User Details</h6>
        <Card>
          <form onSubmit={submitHandler}>
            <Row className="g-3 mb-3">
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Name :</label>
                <Input
                  placeholder="Enter Name"
                  name="name"
                  required
                  value={userData.name}
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        name: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Email :</label>
                <Input
                  placeholder="Enter Email"
                  name="email"
                  required
                  value={userData.email}
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        email: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Mobile No.:</label>
                <Input
                  placeholder="Enter Mobile No."
                  name="mobile"
                  type="number"
                  required
                  value={userData.mobile}
                  onChange={(e) => {
                    if (e.target.value.length > 10) {
                      return false;
                    }
                    setUserData((prev) => {
                      return {
                        ...prev,
                        mobile: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Profile :</label>
                <Select
                  value={userData.profile_id}
                  name="profile_id"
                  required
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        profile_id: e.target.value,
                      };
                    });
                  }}
                >
                  <option value="" disabled>
                    Select Profile
                  </option>
                  {profileList.map((data) => (
                    <option key={data.profile_id} value={data.profile_id}>
                      {data.profile_name}
                    </option>
                  ))}
                </Select>
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Center :</label>
                <Select
                  value={userData.center_id}
                  name="center_id"
                  required
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        center_id: e.target.value,
                      };
                    });
                  }}
                >
                  <option value="" disabled>
                    Select Center
                  </option>
                  {centerList.map((data) => (
                    <option key={data.center_id} value={data.center_id}>
                      {data.center}
                    </option>
                  ))}
                </Select>
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Username :</label>
                <Input
                  placeholder="Enter Username"
                  name="user_name"
                  required
                  value={userData.user_name}
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        user_name: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Password :</label>
                <Input
                  placeholder="Enter Password"
                  type="text"
                  value={userData.password}
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        password: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Confirm password :</label>
                <Input
                  placeholder="Enter password again to confirm"
                  type="text"
                  required
                  name="cnfrm_password"
                  value={userData.cnf_password}
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        cnf_password: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Team Lead :</label>
                <Select
                  value={userData.team_lead_id}
                  name="team_lead"
                  required
                  onChange={(e) => {
                    setUserData((prev) => {
                      return {
                        ...prev,
                        team_lead_id: e.target.value,
                      };
                    });
                  }}
                >
                  {" "}
                  {/* need to get the id of the team lead to the member */}
                  <option value="" disabled>
                    Select Team Lead
                  </option>
                  {teamInfoList.map((data) => (
                    <option key={data.user_id} value={data.user_id}>
                      {data.name}
                    </option>
                  ))}
                </Select>
              </Col>
              <Col className="pe-lg-4" lg={6} md={6} sm={12}>
                <label>Subjects :</label>
                <MultiSelectDropdown
                  options={subjectList}
                  selectedValues={res}
                  displayValue="sub_name"
                  onSelect={onMultiSelect}
                  onRemove={onMultiRemove}
                />
              </Col>
            </Row>
            <div className="d-flex">
              <label htmlFor="custom-switch" className="me-2">
                Activate this User
              </label>
              <ReactSwitch
                onChange={handleSwitch}
                checked={checked}
                className="react-switch"
              />
            </div>
            <div className="my-5 text-center">
              <SecBTN type="submit" className={classes["sec-btn"]}>
                Update User
              </SecBTN>
            </div>
          </form>
        </Card>
      </Graybg>
    </div>
  );
};

export default UpdateUser;
